/* CRO pass 2026-09-30: cart-drawer set upsell (agent B).
   Markup: snippets/az-cart-upsell.liquid (server-rendered inside the cart drawer, so it is
   re-rendered by Horizon's morph on every cart change). Everything here is event delegation
   on document, because morphed HTML never re-runs inline scripts.
   Add flow mirrors initSet() in olympus-landing.js: dispatch Horizon's CartLinesUpdateEvent
   with a deferred promise, POST /cart/add.js with the cart-items-component section ids, fetch
   /cart.js, resolve -> cart-items-component morphs the drawer and the cart count updates. */

if (!window.__azUpsell) {
  window.__azUpsell = true;

  let eventsLib = null;
  const loadEvents = async () => {
    if (eventsLib !== null) return eventsLib;
    try {
      eventsLib = await import('@shopify/events');
    } catch (e) {
      eventsLib = false;
    }
    return eventsLib;
  };

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const routes = () => {
    const r = (window.Theme && window.Theme.routes) || {};
    return {
      add: r.cart_add_url ? r.cart_add_url.replace(/(\.js)?$/, '.js') : root() + 'cart/add.js',
      cart: r.cart_url || root() + 'cart',
    };
  };

  let busy = false;

  const say = (card, text, isError) => {
    const msg = card.querySelector('[data-az-upsell-msg]');
    if (!msg) return;
    msg.textContent = text || '';
    msg.hidden = !text;
    msg.classList.toggle('az-upsell__msg--error', Boolean(isError));
  };

  // Size change: update the price line to the chosen variant (2XL+ cost more).
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'az-upsell-size') return;
    const card = input.closest('[data-az-upsell]');
    if (!card) return;
    const regular = card.querySelector('[data-az-upsell-regular]');
    const promo = card.querySelector('[data-az-upsell-promo]');
    if (regular && input.dataset.price) regular.textContent = input.dataset.price;
    if (promo && input.dataset.promo) promo.textContent = input.dataset.promo;
    card.classList.remove('az-upsell--invalid');
    say(card, '');
  });

  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-az-upsell-add]') : null;
    if (!button) return;
    const card = button.closest('[data-az-upsell]');
    if (!card) return;
    event.preventDefault();
    if (busy) return;

    const checked = card.querySelector('input[name="az-upsell-size"]:checked');
    if (!checked || !checked.value) {
      card.classList.add('az-upsell--invalid');
      say(card, 'Pick a size first.', true);
      const first = card.querySelector('input[name="az-upsell-size"]:not(:disabled)');
      if (first) first.focus();
      return;
    }

    busy = true;
    const label = button.querySelector('[data-az-upsell-label]');
    const labelText = label ? label.textContent : '';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    card.classList.add('az-upsell--busy');
    if (label) label.textContent = '…';
    say(card, '');

    const items = [{ id: Number(checked.value), quantity: 1 }];
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset && el.dataset.sectionId)
      .filter(Boolean);

    const lib = await loadEvents();
    let deferred = null;
    if (lib && lib.CartLinesUpdateEvent) {
      try {
        deferred = lib.CartLinesUpdateEvent.createPromise();
        card.dispatchEvent(
          new lib.CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
            promise: deferred.promise,
          })
        );
      } catch (e) {
        deferred = null;
      }
    }

    let ok = false;
    const r = routes();
    try {
      const res = await fetch(r.add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(sectionIds.length ? { items, sections: sectionIds.join(',') } : { items }),
      });
      const data = await res.json().catch(() => ({}));
      const failed = !res.ok || Boolean(data.status);

      let cart = null;
      try {
        cart = await fetch(r.cart + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((x) => x.json());
      } catch (e) {
        /* ignore */
      }

      if (deferred) {
        if (cart && lib.CartLinesUpdateEvent.createCartFromAjaxResponse) {
          deferred.resolve({
            cart: lib.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              source: 'olympus-cart-upsell',
              itemCount: failed ? 0 : 1,
              sections: failed ? undefined : data.sections,
              didError: failed,
            },
          });
        } else {
          deferred.reject(Object.assign(new Error('cart refresh failed'), { name: 'AbortError' }));
        }
      }

      if (failed) {
        say(card, (data && (data.description || data.message)) || 'Could not add it. Please try again.', true);
        if (lib && lib.CartErrorEvent) {
          try {
            card.dispatchEvent(new lib.CartErrorEvent({ error: data.message || 'Add to cart failed', code: 'INVALID' }));
          } catch (e) {
            /* ignore */
          }
        }
      } else {
        ok = true;
        if (!deferred) {
          // No events library: reload so the drawer and cart count are right.
          window.location.reload();
        }
      }
    } catch (error) {
      if (deferred) deferred.reject(Object.assign(new Error('network'), { name: 'AbortError' }));
      say(card, 'Network hiccup. Check your connection and try again.', true);
    } finally {
      busy = false;
      // On success the drawer morph usually replaces or removes this card; restore it anyway.
      if (card.isConnected) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        card.classList.remove('az-upsell--busy');
        if (label && !ok) label.textContent = labelText;
        // The morph normally rewrites the label (e.g. "Equip the hoodie"); only undo our own busy text.
        if (label && ok) setTimeout(() => { if (label.isConnected && label.textContent === '…') label.textContent = labelText; }, 1500);
      }
    }
  });
}


/* ---------------------------------------------------------------------------
   Drawer close-request guard (main session, 2026-09-30).
   Bug: on phones, the back gesture (Android back / CloseWatcher) closes a modal
   <dialog> natively. Horizon's <theme-drawer> only releases its scroll lock in its
   own close() (X button, backdrop, Escape), so after a back-swipe the drawer
   vanished but the page stayed scroll-locked until refresh. Route native
   cancel/close through theme-drawer's close() so the lock is always released.
   --------------------------------------------------------------------------- */
(() => {
  if (window.__azDrawerGuard) return;
  window.__azDrawerGuard = true;

  const guard = () => {
    document.querySelectorAll('theme-drawer').forEach((drawer) => {
      const panel = drawer.querySelector('dialog');
      if (!panel || panel.__azGuard || typeof drawer.close !== 'function') return;
      panel.__azGuard = true;
      // Close request that still fires 'cancel': let the drawer animate out itself.
      panel.addEventListener('cancel', (event) => {
        if (event.target !== panel || !drawer.isOpen) return;
        event.preventDefault();
        drawer.close();
      });
      // Close request that skipped 'cancel' (no user activation): the dialog is already
      // closed but the drawer still thinks it's open -> run its close() to unlock scroll.
      const settle = () =>
        setTimeout(() => {
          if (drawer.isOpen && !panel.open) drawer.close();
        }, 0);
      panel.addEventListener('close', (event) => {
        if (event.target === panel) settle();
      });
      // Belt and braces: some browsers don't deliver 'close' reliably; watch the
      // dialog's own [open] attribute too.
      new MutationObserver(() => {
        if (!panel.open) settle();
      }).observe(panel, { attributes: true, attributeFilter: ['open'] });
    });
  };

  // Back/forward cache restore with a stale drawer state.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('theme-drawer').forEach((drawer) => {
      const panel = drawer.querySelector('dialog');
      if (drawer.isOpen && panel && !panel.open && typeof drawer.close === 'function') drawer.close();
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guard, { once: true });
  else guard();
  customElements.whenDefined('theme-drawer').then(guard);
  document.addEventListener('shopify:section:load', guard);
})();
